import { Box } from '@mui/material';
import Navbar from '../../components/OCR/navbar/navbar';
import FormCompany from '../../components/OCR/company-form/company-form';
import FormTransportation from '../../components/OCR/forms/transportation-form/transportation-form';
import LoadingDeliveryForm from '../../components/OCR/forms/loading-delivery-form/loading-delivery-form';
import { useLocation } from 'react-router-dom';
import PajamosTable from '../../components/OCR/forms/income-form/income-form';

const OrderPage = () => {
  const location = useLocation();
  const responseData = location.state?.responseData;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        bgcolor: 'background.darkGrey',
      }}
    >
      <Navbar />
      <Box
        sx={{
          width: '91.666667%', // w-11/12
        }}
      >
        <Box
          sx={{
            m: 1,
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
          }}
        >
          <FormCompany data={responseData} />
        </Box>
        <Box
          sx={{
            m: 1,
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
          }}
        >
          <FormTransportation data={responseData} />
        </Box>
        <Box
          sx={{
            bgcolor: 'background.white',
            borderRadius: 1,
            m: 1,
          }}
        >
          <LoadingDeliveryForm data={responseData} />
        </Box>
        <Box sx={{ flexGrow: 1 }} />
      </Box>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
        }}
      >
        <PajamosTable data={responseData} />
      </Box>
    </Box>
  );
};

export default OrderPage;
